import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SideMenu from "../../Components/SideMenu";
import { Col, Row } from "react-bootstrap";
import { getMessaage } from "../../reducers/commonReducer";
import { home } from "../../const";

const Message = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!localStorage.getItem("x-auth-token")) {
      navigate(home);
    }
    dispatch(getMessaage());
  }, []);

  const { getMessaageList } = useSelector((state) => state.commonReducer);
  return (
    <>
      <SideMenu />
      <div className="mt-extra content container-fluid">
        <table className="table w-100">
          <thead className="normalplace">
            <tr>
              <th className="over-col-size">Sr</th>
              <th className="over-col-size">Name</th>
              <th className="over-col-size">Set As Primary</th>
              <th className="over-col-size">Description</th>
              <th className="over-col-size">Status</th>
              <th className="over-col-size">Action</th>
            </tr>
          </thead>
          <tbody>
            {!!getMessaageList &&
              getMessaageList?.map((data, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr key={index}>
                      <td>{index + 1}.</td>
                      <td>{data?.name}</td>
                      <td>
                        <b>{data?.setAsPrimary ? <span className="text-success">Active</span> : 
                        <span className="text-danger">InActive</span>}</b>
                      </td>
                      <td>{data?.description}</td>
                      <td>
                        <b>{data?.status ? <span className="text-success">Active</span> : 
                        <span className="text-danger">InActive</span>}</b>
                      </td>
                      <td>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Message;
